import {
  PropertyTranslator,
  IEntryRecordParametersTranslator,
  IModifiedRecordParametersTranslator,
  IEntryRecordLabels,
  IModificationRecordLabels,
  IUniqueEntityLabels,
  IRelatedEntityLabels,
  ICustomFieldSearchTranslator,
} from "../GenericTranslator";
import {
  IUniqueEntity,
  IEntryRecord,
  IRelatedEntity,
  IModificationRecord,
  IRelationModel,
  EntryRecordOrderBy,
  ModificationRecordOrderBy,
  ICreatedRecordParameters,
  IModifiedRecordParameters,
  EntityConstants,
  ICustomFieldSearch,
  IEntityMinimalModel,
} from "../GenericTypes";
import {
  CustomFieldBase,
  CustomFieldBaseFieldLabels,
  CustomFieldBaseFilters,
  CustomFieldBaseFiltersTranslator,
  CustomFieldBaseSortingOptionsConsts,
} from "./CustomFieldsBase";

export const customFieldTemplateConstants: EntityConstants<CustomFieldTemplate, CustomFieldTemplateFilters> = {
  resource: "custom_field_templates",
  frontendIndexRoute: "custom_field_templates",
  entitySingular: "custom field template",
  entityPlural: "custom field templates",
  icon: "copy-minus",
};

export interface CustomFieldTemplate
  extends
    CustomFieldBase,
    IUniqueEntity,
    IEntryRecord,
    IModificationRecord,
    IRelatedEntity<CustomFieldTemplateRelations> {
  customFieldsFromCurrentTemplate?: IEntityMinimalModel[];
}

export const CustomFieldTemplateLabels: PropertyTranslator<CustomFieldTemplate> = {
  ...CustomFieldBaseFieldLabels,
  ...IUniqueEntityLabels,
  ...IEntryRecordLabels,
  ...IModificationRecordLabels,
  ...IRelatedEntityLabels,
  customFieldsFromCurrentTemplate: "Custom fields using this template",
} as const;

export interface CustomFieldTemplateRelations extends IRelationModel {}

export interface CustomFieldTemplateFilters
  extends
    CustomFieldBaseFilters<CustomFieldTemplateSortingOptions>,
    ICustomFieldSearch,
    ICreatedRecordParameters,
    IModifiedRecordParameters {
  customTypeTemplatePackageIds?: number[] | null;
  customTypeTemplateIds?: number[] | null;
}

export const CustomFieldTemplateSortingOptionsConsts = [
  ...CustomFieldBaseSortingOptionsConsts,
  ...EntryRecordOrderBy,
  ...ModificationRecordOrderBy,
] as const;
export type CustomFieldTemplateSortingOptions = (typeof CustomFieldTemplateSortingOptionsConsts)[number];

export const CustomFieldTemplateFiltersTranslator: PropertyTranslator<CustomFieldTemplateFilters> = {
  ...ICustomFieldSearchTranslator,
  ...CustomFieldBaseFiltersTranslator,
  ...IEntryRecordParametersTranslator,
  ...IModifiedRecordParametersTranslator,
  customTypeTemplatePackageIds: "Custom type template package IDs",
  customTypeTemplateIds: "Custom type template IDs",
} as const;
